import { Outlet, Navigate } from 'react-router-dom';
import UserService from 'services/userService';

export default function PublicRoute({ element }) {
  const currentUser = UserService.getCurrentUser();

  if (currentUser) {
    return <Navigate to="/" replace />;
  }

  return element ?? <Outlet />;
}
